import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OrderService } from "src/app/core/services/order.service";
import { CheckItemDto } from "../../models/check-dto";
import { PromoCodeUsage, PromoCodeValidationRequestDto, PromoCodeValidationResponseDto } from "../../models/DTO/promo-code-validation.dto";
import { AppMessageSeverity } from "../../models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-order-promo-code",
	templateUrl: "./order-promo-code.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class OrderPromoCodeComponent implements OnInit {
	@Input() transactionType: number;

	promoCodeEnabled: boolean;
	promoCode: string;

	moment: any = moment;

	constructor(public app: AppService, private focuslink: FocuslinkService, public orderService: OrderService) {}

	ngOnInit(): void {
		if (!this.orderService.venueService.ooMenuItems || this.orderService.venueService.ooMenuItems.length === 0) {
			this.orderService.venueService.menuItemsGet();
		}
	}

	async validate() {
		const validationRequest = new PromoCodeValidationRequestDto({
			transactionType: this.transactionType,
			checkAmount: this.orderService.activeSeat.value.total,
			checkDate: moment().format(),
			menuItemKeys: this.orderService.activeSeat.value.items.map((itm) => itm.menuItemKey),
			promoCode: this.promoCode,
		});
		try {
			const resp = await this.focuslink.promoCodeValidate(this.orderService.venueService.venueKey, validationRequest);

			this.applyPromoCode(new PromoCodeValidationResponseDto(resp));
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `${error.error}` });
		}
	}

	async applyPromoCode(promoCodeResponse: PromoCodeValidationResponseDto) {
		let promoCodeValueSum: 0;
		const promoCodeUsage: PromoCodeUsage[] = [];

		promoCodeResponse.appliedPromoCodes.forEach((pc) => {
			promoCodeValueSum += pc.value;
			promoCodeUsage.push(
				new PromoCodeUsage({
					tranDateTime: moment().format(),
					checkKey: this.orderService.activeOrder.value.checkKey,
					amount: pc.value,
					promoCodeKey: pc.promoCodeKey,
				})
			);
			this.orderService.orderAddItemToSeat(
				new CheckItemDto({
					menuItemKey: pc.menuItemKey,
					quantity: 1,
					name: this.orderService.venueService.ooMenuItems.find((menuItem) => menuItem.menuItemKey === pc.menuItemKey).name,
					price: pc.value,
				}),
				this.orderService.activeSeat.value.seatKey,
				false
			);
		});

		try {
			await this.orderService.submitOrderToPos(this.orderService.activeOrder.value);
			// this.focuslink.promoCodeUse(this.orderService.venueService.venueKey, "", promoCodeUsage);
			this.app.msgSvc.add({
				severity: AppMessageSeverity.GREEN,
				summary: "",
				detail: `🥳. ${this.promoCode} saved you $${promoCodeValueSum.toFixed(2)}`,
			});
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Sorry, there was an error applying your promo code.` });
		}
	}
}
